import React from 'react';
import { Row, Col, Card, Space, Typography, Skeleton, Empty, Button, Tooltip } from 'antd';
import { CarryOutOutlined, WarningOutlined, InfoCircleOutlined, ClockCircleOutlined, DownloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

const CriticalActions = ({ loading, onExport }) => {
  return (
    <Card
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Space>
            <CarryOutOutlined style={{ color: '#ef4444', fontSize: 18 }} />
            <span style={{ fontWeight: 800 }}>Casos Prioritários (Ação Necessária)</span>
          </Space>
          {!loading && <Text type="secondary" style={{ fontSize: 12 }}>Atualizado agora</Text>}
        </div>
      }
      extra={
        onExport && (
          <Tooltip title="Exportar ações críticas">
            <Button 
              type="text" 
              icon={<DownloadOutlined style={{ fontSize: 16 }} />} 
              onClick={onExport}
              style={{ color: '#64748b' }}
            />
          </Tooltip>
        )
      }
      bordered={false}
      style={{ borderRadius: 24, boxShadow: '0 4px 20px rgba(0,0,0,0.03)', marginTop: 24 }}
    >
      {loading ? (
        <Skeleton active paragraph={{ rows: 4 }} />
      ) : (
        <Row gutter={[16, 16]}>
          <Col xs={24} md={8}>
            <div style={{ background: '#fef2f2', padding: 20, borderRadius: 16, border: '1px solid #fee2e2' }}>
              <Space style={{ marginBottom: 12 }}>
                <WarningOutlined style={{ color: '#ef4444', fontSize: 20 }} />
                <Text strong style={{ color: '#991b1b' }}>Sem Qualquer Dados</Text>
              </Space>
              <div style={{ fontSize: 28, fontWeight: 900, color: '#991b1b' }}>0</div>
              <Text style={{ fontSize: 12, color: '#b91c1c', display: 'block' }}>Empresas sem integração ou envio de documentos este mês.</Text>
            </div>
          </Col>
          <Col xs={24} md={8}>
            <div style={{ background: '#fffbeb', padding: 20, borderRadius: 16, border: '1px solid #fef3c7' }}>
              <Space style={{ marginBottom: 12 }}>
                <InfoCircleOutlined style={{ color: '#d97706', fontSize: 20 }} />
                <Text strong style={{ color: '#92400e' }}>Pendências de Extrato</Text>
              </Space>
              <div style={{ fontSize: 28, fontWeight: 900, color: '#92400e' }}>0</div>
              <Text style={{ fontSize: 12, color: '#a16207', display: 'block' }}>Contas bancárias com dias sem conciliação.</Text>
            </div>
          </Col>
          <Col xs={24} md={8}>
            <div style={{ background: '#f0f9ff', padding: 20, borderRadius: 16, border: '1px solid #e0f2fe' }}>
              <Space style={{ marginBottom: 12 }}>
                <ClockCircleOutlined style={{ color: '#0284c7', fontSize: 20 }} />
                <Text strong style={{ color: '#075985' }}>Aguardando Cliente</Text>
              </Space>
              <div style={{ fontSize: 28, fontWeight: 900, color: '#075985' }}>0</div>
              <Text style={{ fontSize: 12, color: '#0369a1', display: 'block' }}>Empresas com lançamentos 'N' aguardando retorno.</Text>
            </div>
          </Col>
        </Row>
      )}
    </Card>
  );
};

export default CriticalActions;

